import { request } from '../../helpers'

export default {
  async getProductDetails(productId) {
    const response = (await request({ url: `/store/products/${productId}`, allow404: true, expand: ['images', 'variants', 'variants.images', 'product_variant_attributes'] }))
    if (response.status === 404)
      return null
    else return response.data
  },
  async getProductVariants(productId) {
    const response = (await request({ url: `/store/product_variants/${productId}`, allow404: true }))
    if (response.status === 404)
      return null
    else return response.data
  },
  async getListProductVariants() {
    const response = (await request({ url: '/store/product_variants', allow404: true }))
    if (response.status === 404)
      return null
    else return response.data
  },
  async getOrdersList({ queryParameters = {}, expand = [], fields = [] } = {}) {
    return (
      await request({
        method: 'GET',
        url: 'store/orders',
        queryParameters,
        expand,
        fields,
      })
    ).data
  },
  async getOrderDetailsById(expand = [], id) {
    return (
      await request({
        method: 'GET',
        url: `store/orders/${id}`,
        expand,
      })
    ).data
  },
  async listProducts({ queryParameters = {}, expand = [] } = {}) {
    return (await request({ url: 'store/products', queryParameters, expand })).data
  },

  async getCurrentOrder({ expand = [], headers = {} } = {}) {
    return (
      await request({
        url: 'store/orders/current_order',
        expand,
        headers,
      })
    ).data
  },

  async addItemToOrder({ data = {}, headers = {} } = {}) {
    return (
      await request({
        method: 'POST',
        url: 'store/order_items',
        data,
        headers,
      })
    ).data
  },

  async deleteOrderItem(orderItemId, { headers = {} } = {}) {
    return (
      await request({
        method: 'DELETE',
        url: `store/order_items/${orderItemId}`,
        headers,
      })
    ).data
  },

  async updateOrderItem(id, { data = {}, headers = {} } = {}) {
    return (
      await request({
        method: 'PATCH',
        url: `store/order_items/${id}`,
        data,
        headers,
      })
    ).data
  },

  async checkoutOrder({ data = {}, headers = {} } = {}) {
    return (
      await request({
        method: 'POST',
        url: '/store/orders/checkout',
        data,
        headers,
      })
    ).data
  },
}
